import { API_URL } from "../../config/connect";

export async function saveDeviceToken(deviceData, forceUpdate = false) {
    // Нормализуем базовый URL, чтобы не было двойных слэшей при REACT_APP_API_URL с `/` на конце
    const normalizedBaseUrl = API_URL.replace(/\/+$/, "");
    const endpoint = `${normalizedBaseUrl}/api/v1/device`;

    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        // Check if device is already registered to prevent duplicate requests
        // But allow updates if forceUpdate is true (e.g., for token updates)
        const isDeviceRegistered = localStorage.getItem('device_registered') === 'true';
        if (isDeviceRegistered && !forceUpdate) {
            if (process.env.NODE_ENV === 'development') {
                console.debug('Device already registered, skipping API call');
            }
            return { success: true, message: 'Device already registered' };
        }

        // Removed verbose logging - only log in debug mode
        if (process.env.NODE_ENV === 'development') {
            console.debug('Sending device data to backend:', deviceData);
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(deviceData)
        });

        if (!response.ok) {
            let errorMessage = `Error: ${response.statusText}`;
            try {
                const errorData = await response.json();
                
                // Check if it's a known backend error (like datetime error)
                const isKnownError = errorData?.error?.message?.includes('datetime') || 
                                  errorData?.message?.includes('datetime');
                
                // Only log detailed errors for unexpected issues
                if (!isKnownError && response.status !== 500) {
                    console.warn('Backend error:', errorData);
                } else if (isKnownError) {
                    // Known backend bug - just log a debug message
                    console.debug('Backend datetime error (known issue):', errorData?.error?.message || errorData?.message);
                }
                
                // Try to extract more specific error message
                if (errorData.error) {
                    if (typeof errorData.error === 'object') {
                        errorMessage = JSON.stringify(errorData.error);
                    } else {
                        errorMessage = errorData.error;
                    }
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.detail) {
                    errorMessage = errorData.detail;
                }
            } catch (parseError) {
                // Silently handle parse errors
            }
            throw new Error(errorMessage);
        }

        const result = await response.json();
        if (process.env.NODE_ENV === 'development') {
            console.debug('Device token saved successfully');
        }
        return result;
    } catch (error) {
        // Only log unexpected errors (not known backend bugs)
        const errorMessage = error?.message || error?.toString() || '';
        if (!errorMessage.includes('datetime')) {
            console.warn('Failed to save device token:', errorMessage);
        }
        throw error;
    }
}
